module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "full-screen",
    attrs: {
      "title": ""
    }
  }, [_c('router-link', {
    staticClass: "close",
    attrs: {
      "to": "../../"
    }
  }, [_c('span', {
    staticClass: "close__title"
  }, [_vm._v("Esc")])]), _vm._v(" "), _c('div', {
    staticClass: "add-pharmacy-wrapper"
  }, [_c('div', {
    staticClass: "pre-title"
  }, [_vm._v("Заменить эталонной")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('p', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('select-material', {
    attrs: {
      "isMulti": false,
      "title": "Аптека",
      "possibleValues": _vm.pharmaciesList,
      "allowSearch": true
    },
    on: {
      "select": function($event) {
        _vm.pharmacy = $event
      }
    }
  })], 1), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('select-material', {
    attrs: {
      "isMulti": false,
      "title": "Стеллаж",
      "possibleValues": _vm.rackList
    },
    on: {
      "select": function($event) {
        _vm.rack = $event
      }
    }
  })], 1), _vm._v(" "), _c('p', [_c('select-material', {
    attrs: {
      "isMulti": false,
      "title": "Полка",
      "possibleValues": _vm.shelfList
    },
    on: {
      "select": function($event) {
        _vm.shelf = $event
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "20px"
    }
  }, [_c('a', {
    staticClass: "button",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.link()
      }
    }
  }, [_vm._v("Копировать")])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-10abc176","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pharmacy/LinkShelf.vue
// module id = 229
// module chunks = 1